import { render, staticRenderFns } from "./CustomerDetailPage.vue?vue&type=template&id=5a411d85&scoped=true&"
import script from "./CustomerDetailPage.vue?vue&type=script&lang=js&"
export * from "./CustomerDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDetailPage.vue?vue&type=style&index=0&id=5a411d85&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a411d85",
  null
  
)

export default component.exports